<template>
  <div>
    <span
      v-for="(tab,index) in tabs"
      :key="index"
    >
      <b-button
        v-if="tab.permission"
        variant="outline-primary"
        class="btn-pill text-capitalize mr-1 mb-1"
        tag="a"
        :class="{'btn-primary':selectedTab===index}"
        size="sm"
        @click="setTabIndex(index)"
      >
        {{ tab.name }}
      </b-button>
    </span>
  </div>
</template>

<script>
export default {
  name: 'FinanceTabs',
  props: {
    selectedTab: { type: Number, default: 0 },
    tabs: { type: Array, default: () => [] },
  },
  methods: {
    setTabIndex(index) {
      this.$emit('update:selectedTab', index)
    },
  },
}
</script>

<style>

</style>
